import { render, staticRenderFns } from "./Pagenav.vue?vue&type=template&id=2695eaea&scoped=true&lang=pug&"
import script from "./Pagenav.vue?vue&type=script&lang=js&"
export * from "./Pagenav.vue?vue&type=script&lang=js&"
import style0 from "./Pagenav.vue?vue&type=style&index=0&id=2695eaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695eaea",
  null
  
)

export default component.exports